import { Box } from 'braid-design-system';

import Logo from './Logo/Logo';

export const BasicHeader = () => (
  <Box paddingX="gutter" paddingY="small" background="surface">
    <Logo />
  </Box>
);
